export default function Fan(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0003 3.65015C29.2852 3.65015 33.1644 5.38694 35.9724 8.19495C38.7804 11.003 40.5172 14.8822 40.5172 19.1671C40.5172 23.4519 38.7804 27.3312 35.9724 30.1392C33.1644 32.9472 29.2852 34.684 25.0003 34.684C20.7154 34.684 16.8362 32.9472 14.0282 30.1392C11.2202 27.3312 9.4834 23.4519 9.4834 19.1671C9.4834 14.8822 11.2202 11.003 14.0282 8.19495C16.8362 5.38694 20.7154 3.65015 25.0003 3.65015Z"
                stroke="#757575"
                strokeWidth="1.80804"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0001 15.2571C26.0798 15.2571 27.0572 15.6947 27.7647 16.4022C28.4723 17.1098 28.9099 18.0872 28.9099 19.1669C28.9099 20.2465 28.4723 21.224 27.7647 21.9315C27.0572 22.639 26.0798 23.0766 25.0001 23.0766C23.9205 23.0766 22.943 22.639 22.2355 21.9315C21.5279 21.224 21.0903 20.2465 21.0903 19.1669C21.0903 18.0872 21.5279 17.1098 22.2355 16.4022C22.943 15.6947 23.9205 15.2571 25.0001 15.2571Z"
                stroke="#757575"
                strokeWidth="1.80804"
            />
            <path
                d="M26.3584 14.6803C27.5078 10.2599 28.7226 7.76054 29.8167 8.06873C31.4579 8.53102 33.9354 10.1074 33.6726 12.1622C33.4502 13.9015 31.3851 16.3727 28.8689 18.4679"
                stroke="#757575"
                strokeWidth="1.80804"
            />
            <path
                d="M28.4641 21.533C32.313 23.9922 34.3146 25.9198 33.6834 26.8651C32.7366 28.2831 30.4718 30.1522 28.5988 29.2673C27.0133 28.5183 25.3012 25.7907 24.0862 22.7502"
                stroke="#757575"
                strokeWidth="1.80804"
            />
            <path
                d="M20.6339 20.6561C16.4118 22.3984 13.6847 22.9324 13.2724 21.8731C12.6539 20.2842 12.4218 17.3569 14.2211 16.3301C15.744 15.461 18.9603 15.6231 22.1479 16.3717"
                stroke="#757575"
                strokeWidth="1.80804"
            />
            <path d="M23.6327 35.0693L22.6206 43.2097" stroke="#757575" strokeWidth="1.80804" />
            <path d="M28.5073 35.0332L29.7782 43.1372" stroke="#757575" strokeWidth="1.80804" />
            <path
                d="M35.5875 43.4175H16.0387C15.2289 43.4175 14.5725 44.0739 14.5725 44.8836C14.5725 45.6934 15.2289 46.3498 16.0387 46.3498H35.5875C36.3973 46.3498 37.0537 45.6934 37.0537 44.8836C37.0537 44.0739 36.3973 43.4175 35.5875 43.4175Z"
                stroke="#757575"
                strokeWidth="1.80804"
            />
            <path d="M33.1755 40.2017V42.9601" stroke="#757575" strokeWidth="1.80804" strokeLinecap="round" />
        </svg>
    );
}
